export default {
  head() {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    const head = {
      title: this.metaTitle,
      htmlAttrs: {
        ...i18nHead.htmlAttrs,
      },
      meta: [...i18nHead.meta],
      link: [
        ...i18nHead.link.map((link) => {
          switch (link.rel) {
            case 'alternate':
              if (link.hreflang) {
                link.href =
                  process.env.VUE_APP_BASE_URL +
                  this.$localeResolver.switchLocalePath(
                    link.hreflang === 'x-default'
                      ? this.$i18n.defaultLocale
                      : link.hreflang.replace('-', '_')
                  )
              }
              return link

            case 'canonical':
              if (link.rel === 'canonical' && this.article) {
                const localePath = this.article.isHearingStory
                  ? this.$localeResolver.localePath('/hear')
                  : this.$localeResolver.localePath(`/learn`)
                const topicsSlug = this.article.isHearingStory
                  ? 'story'
                  : this.article.topics[0].slug

                link.href = `${document.location.origin}${localePath}/${topicsSlug}/${this.article?.slug}`
              }
              return link
          }
          return link
        }),
      ],
    }

    if (this.metaTitle) {
      head.meta.push({
        hid: 'og:title',
        property: 'og:title',
        content: this.metaTitle,
      })
    }

    if (this.metaDescription) {
      head.meta.push({
        hid: 'description',
        property: 'description',
        name: 'description',
        content: this.metaDescription,
      })
      head.meta.push({
        hid: 'og:description',
        property: 'og:description',
        content: this.metaDescription,
      })
    }

    if (this.ogImage) {
      head.meta.push({
        hid: 'og:image',
        property: 'og:image',
        content: this.ogImage,
      })
    }

    return head
  },
}
